import { FunctionComponent } from "react"
import TableButton, { TableButtonProps } from "./table-button"

type TableTopProps = {
  buttons?: TableButtonProps[]
}

const TableTop: FunctionComponent<TableTopProps> = ({ buttons }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {buttons &&
        buttons.map(
          (button, index) =>
            !button.hide && (
              <TableButton
                key={index}
                action={button.action}
                label={button.label}
                icon={button.icon}
                disable={button.disable}
              />
            ),
        )}
    </div>
  )
}

export default TableTop
